import {
  createFileRoute,
  useMatches,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { Route as ProductRoute } from "../route.tsx";
import { DetailDrawer } from "../../../components/DetailDrawer.tsx";
import { useMemo } from "react";
import { getProductDetailTabs } from "../../../components/ProductDetailTabs/getProductDetailTabs.tsx";

export const Route = createFileRoute("/products/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const search = useSearch({ from: "/products/$id" });
  const matches = useMatches();
  const productDetailMatch = matches.find((m) => m.routeId === "/products/$id");
  const selectedProductId = productDetailMatch?.params.id ?? null;

  const drawerOpen = !!selectedProductId;

  const tabs = useMemo(() => {
    return selectedProductId
      ? getProductDetailTabs({ productCode: selectedProductId })
      : [];
  }, [selectedProductId]);
  return (
    <DetailDrawer
      open={drawerOpen}
      onClose={() => {
        navigate({ to: ProductRoute.fullPath, from: "/products", search });
      }}
      tabs={tabs}
    />
  );
}
